import { isValidPhoneNumber } from 'libphonenumber-js';

const phoneNumber = (number) => {
  if (!number) return true;
  return isValidPhoneNumber(number);
};

export { phoneNumber };
